'use client'

/**
 * Whether a note's recording is still uploading audio after Stop, in this
 * page (#14423). Reads `@/lib/notetaker/late-audio-uploads`, which the bar's
 * capture reports to while its queue drains in the background.
 *
 * `false` on the server and during hydration: only the browser that captured
 * the audio is sending it, so a server render never has anything to say.
 */

import { useSyncExternalStore } from 'react'

import {
  isLateAudioUploadingForNote,
  subscribeLateAudio,
} from '@/lib/notetaker/late-audio-uploads'

export function useLateAudioUploading(noteId: string | null): boolean {
  return useSyncExternalStore(
    subscribeLateAudio,
    () => isLateAudioUploadingForNote(noteId),
    () => false,
  )
}
